import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const PROFILE_REQUEST_REVIEWS_OFFER_SCHEMA = Object.freeze({
  CLIENT_IDS: '',
});
const RECORD = generateSchema(PROFILE_REQUEST_REVIEWS_OFFER_SCHEMA);
const KEYS: any = generateKeys(PROFILE_REQUEST_REVIEWS_OFFER_SCHEMA);

export class ProfileRequestReviewsTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.profile_request_reviews;
  }

  get properties() {
    return this.toJS();
  }
}
